/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_HintInputs */

const en_image_inspector_hint = /** @type {(inputs: Image_Inspector_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`scroll to zoom · drag to pan · I`)
};

const ar_image_inspector_hint = /** @type {(inputs: Image_Inspector_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تمرير للتكبير · سحب للتحريك · I`)
};

const bn_image_inspector_hint = /** @type {(inputs: Image_Inspector_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`জুম করতে স্ক্রল · প্যান করতে ড্র্যাগ · I`)
};

const de_image_inspector_hint = /** @type {(inputs: Image_Inspector_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scroll zum Zoomen · Ziehen zum Verschieben · I`)
};

const es_image_inspector_hint = /** @type {(inputs: Image_Inspector_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`desplaza para ampliar · arrastra para mover · I`)
};

const fr_image_inspector_hint = /** @type {(inputs: Image_Inspector_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`défiler pour zoomer · glisser pour déplacer · I`)
};

const pt_image_inspector_hint = /** @type {(inputs: Image_Inspector_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`rolar para ampliar · arrastar para mover · I`)
};

const zh_image_inspector_hint = /** @type {(inputs: Image_Inspector_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`滚动缩放 · 拖动平移 · I`)
};

const tr_image_inspector_hint = /** @type {(inputs: Image_Inspector_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`yakınlaştırmak için kaydır · taşımak için sürükle · I`)
};

const ru_image_inspector_hint = /** @type {(inputs: Image_Inspector_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`прокрутка для масштаба · перетаскивание для перемещения · I`)
};

const pl_image_inspector_hint = /** @type {(inputs: Image_Inspector_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`przewiń, aby powiększyć · przeciągnij, aby przesunąć · I`)
};

/**
* | output |
* | --- |
* | "scroll to zoom · drag to pan · I" |
*
* @param {Image_Inspector_HintInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_hint = /** @type {((inputs?: Image_Inspector_HintInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_HintInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_hint(inputs)
	if (locale === "bn") return bn_image_inspector_hint(inputs)
	if (locale === "de") return de_image_inspector_hint(inputs)
	if (locale === "es") return es_image_inspector_hint(inputs)
	if (locale === "fr") return fr_image_inspector_hint(inputs)
	if (locale === "pt") return pt_image_inspector_hint(inputs)
	if (locale === "zh") return zh_image_inspector_hint(inputs)
	if (locale === "tr") return tr_image_inspector_hint(inputs)
	if (locale === "ru") return ru_image_inspector_hint(inputs)
	if (locale === "pl") return pl_image_inspector_hint(inputs)
	return en_image_inspector_hint(inputs)
});